import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const CustomSnackBar = styled(Snackbar)(({theme}) => ({
  "&.MuiSnackbarContent-action" : {
    "padding-bottom": "15px",
    "padding-left": "0xp",
  }
}));

const Header = (props) => {
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (
    event,
    reason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const action = (
    <div className="snack-info">
      <p>Die Nebelkarte ist wieder da! Vielen Dank an den Bachelor-Studiengang Informatik der FH OST für die Unterstützung.<br />Schreibt uns eine <a href="mailto:stefan.keller@ost.ch?subject=Nebelkarte-Feedback">E-Mail</a> (eventuell mit Foto) und erzählt uns vom Nebel und davon, was ihr mit der Nebelkarte macht.</p>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>
  );

  const vertical = 'bottom'
  const horizontal = 'center'

  return (
    <div>
      <CustomSnackBar
        open={open}
        onClose={handleClose}
        action={action}
        anchorOrigin={{ vertical, horizontal }}
      />
    </div>
  );
}

export default Header
